import { useState, useEffect } from "react";
import { KeyValueObj } from "../common/types";
import { useAxiosAuth } from "./useAxiosAuth";
import useLogout from "./useLogout";

interface UseQueryReturn<T> {
  data: T;
  error: string;
  loading: boolean;
  meta: KeyValueObj;
  refetch: (url?: string) => void;
}

const useQuery = <T = any>(
  url: string,
  enabled: boolean = true
): UseQueryReturn<T> => {
  const [response, setResponse] = useState<T>([] as T);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState<KeyValueObj>({});
  const [requestUrl, setrequestUrl] = useState("");
  const logout = useLogout();

  const axiosAuth = useAxiosAuth();
  useEffect(() => {
    if (enabled) {
      axiosCall(url);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, enabled]);

  async function axiosCall(url: string) {
    setrequestUrl(url);
    setLoading(true);
    try {
      const res = await axiosAuth.get(url);
      if (res.data.success) {
        setMeta(res.data.meta);
        setResponse(res.data.data);
        setError("");
      } else {
        setError("Something went wrong");
      }
    } catch (err: any) {
      if (err?.response?.request?.status === 401) {
        return logout();
      }
      setError(err);
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  function refetch(url?: string) {
    axiosCall(url || requestUrl);
  }
  return { data: response, error, loading, meta, refetch };
};

export default useQuery;
